import CardWithTitle from "features/affiliation/common/CardWithTitle";
import {
  AffiliationTabs,
  UsersStatisticsTypes,
} from "features/affiliation/common/types";
import StatisticsRow from "features/affiliation/common/StatisticsRow";
import React from "react";
import useReferredUsers from "features/affiliation/common/hooks/useReferredUsers";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

const OverviewExistingUsersStatistics = () => {
  const { statistics, getStatisticTotalValue, getStatisticLastMonthValue } =
    useReferredUsers(AffiliationTabs.EXISTING_USERS);
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);

  return (
    <CardWithTitle
      title={t("tabs.existing_users")}
      relatedTab={AffiliationTabs.EXISTING_USERS}
    >
      <StatisticsRow<UsersStatisticsTypes>
        statisticsTitles={statistics}
        getStatisticValue={getStatisticTotalValue}
        getLastMonthChangeValue={getStatisticLastMonthValue}
      />
    </CardWithTitle>
  );
};

export default OverviewExistingUsersStatistics;
